import { render, staticRenderFns } from "./ipWhite.vue?vue&type=template&id=2261d430&scoped=true"
import script from "./ipWhite.vue?vue&type=script&lang=js"
export * from "./ipWhite.vue?vue&type=script&lang=js"
import style0 from "./ipWhite.vue?vue&type=style&index=0&id=2261d430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2261d430",
  null
  
)

export default component.exports